import MainCarousel from "./MainCarousel";
import ReviewCarousel from "./ReviewCarousel";
import { Box, Typography, Button, useTheme } from "@mui/material";
import { shades } from "../../theme";
import { useNavigate, Link as RouterLink } from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  return (
    <div className="home">
      <MainCarousel />

      {/* Business Closure Notice */}
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        width="80%"
        margin="80px auto"
        maxWidth="1200px"
        sx={{
          backgroundColor: shades.neutral[100],
          padding: { xs: "20px", md: "40px" },
          borderRadius: "8px",
          boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
          "& .MuiTypography-paragraph": {
            fontSize: "16px",
            lineHeight: 1.8,
            color: shades.neutral[800]
          }
        }}
      >
        <Typography
          variant="h3"
          textAlign="center"
          marginBottom="20px"
          sx={{
            fontSize: { xs: "24px", md: "32px" },
            color: "#d32f2f",
            fontWeight: "bold",
            textTransform: "uppercase",
            letterSpacing: "1px"
          }}
        >
          The End of the Road for Road Race 1
        </Typography>

        <Typography
          variant="h5"
          textAlign="center"
          marginBottom="40px"
          sx={{
            fontSize: { xs: "16px", md: "20px" },
            color: shades.neutral[700],
            fontWeight: "500"
          }}
        >
          Effective December 14, 2025
        </Typography>

        <Typography paragraph marginBottom="24px" sx={{ fontWeight: "600", textAlign: "left" }}>
          This is a hard message to write.
        </Typography>

        <Typography paragraph marginBottom="24px" sx={{ textAlign: "left" }}>
          After much thought, we've made the decision to close Road Race 1 as a business selling performance parts and components. A mix of challenges made it impossible for us to continue in that capacity. This wasn't an easy choice, and it comes with a lot of emotion.
        </Typography>

        <Typography paragraph marginBottom="24px" sx={{ textAlign: "left" }}>
          What hasn't changed is our passion for racing and for this community. We're still racers at heart, still deeply involved, and still committed to giving back to the community that supported us from the beginning. Road Race 1 may no longer be selling parts, but the passion behind it hasn't gone anywhere.
        </Typography>

        <Typography paragraph marginBottom="24px" sx={{ textAlign: "left" }}>
          Road Race 1 started as a passion project and grew into something much bigger because of the incredible community behind it. To every customer, supporter, and friend who believed in us—thank you. Your trust and support meant more than we can properly express.
        </Typography>

        <Typography paragraph marginBottom="24px" sx={{ textAlign: "left" }}>
          Although Road Race 1 is no longer operating as a parts business, we're still here in a limited way. We're happy to help with questions related to past orders and to offer advice where we can—especially to those we've worked with over the years.
        </Typography>

        <Typography paragraph marginBottom="24px" sx={{ textAlign: "left" }}>
          We do have ideas for the future, but for now, Road Race 1 is closed when it comes to selling parts. If new offerings or opportunities take shape down the road, we'll be sure to share them with the community.
        </Typography>

        <Typography paragraph marginBottom="32px" sx={{ fontWeight: "500", textAlign: "left" }}>
          For questions or opportunities, please contact:{" "}
          <a
            href="mailto:shawn@roadrace1.com"
            style={{
              color: shades.secondary[500],
              textDecoration: "none",
              fontWeight: "bold"
            }}
          >
            shawn@roadrace1.com
          </a>
        </Typography>

        <Typography
          paragraph
          sx={{
            fontSize: "16px",
            fontStyle: "italic",
            color: shades.neutral[700],
            marginTop: "20px",
            textAlign: "left",
            lineHeight: 1.8
          }}
        >
          Thank you for being part of the Road Race 1 journey. We're truly grateful for every track day we shared, every phone call and email, and every conversation about Mustangs—how to make them last, and how to make them go fast. Those moments are what made this more than just a business.
        </Typography>

        <Typography
          paragraph
          sx={{
            fontSize: "16px",
            fontWeight: "600",
            color: shades.neutral[800],
            marginTop: "32px",
            textAlign: "left"
          }}
        >
          — Shawn & Nick
        </Typography>
      </Box>
    </div>
  );
};

export default Home;
